<app-load-dropdown-data [formName]="commonVoucherModel?.formName" [isInvoiceNo]="commonVoucherModel?.isInvoiceNo"
    (fillDropdownData)="fillDropdownData()" (onPrint)="onPrint($event)"></app-load-dropdown-data>
<div  [ngClass]="{'disabled-div': commonVoucherModel.disableMetalSection === true}"
    class="container-fluid d-flex flex-column h-100 px-0 sale_invoice_container">
    <form  *ngIf="commonVoucherModel.showTopSection" class="theme-form" ngNativeValidate #InvoiceForm="ngForm">
        <div class="row py-1 mx-0">
            <div class="col-10">
                <div class="row gap-1 py-1 mx-0">
                    <div *ngIf="commonVoucherModel?.showExpensesWithTaxSwitch"
                        class="col-2 p-0 d-flex align-items-center">
                        <div class="swith_toggler_input w-100">
                            <span class="d-block w-100 f-13 font-regular text-gray-color text-nowrap">Expenses With
                                Tax</span>
                            <app-toggle-switch [switchStatus]="formModel?.invoiceModel?.expensesWithTax"
                                (changeStatus)="onChangeSwitch($event)"></app-toggle-switch>
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel?.showDepartment" class="col-3 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="category"
                                class="f-14 font-semibold text-gray-color text-nowrap mb-0">Department</label>
                        </div>
                        <div class="w-100">
                            <app-select [options]="getAllDropdownModel?.departmentDropdown"
                                [selectedValue]="formModel?.invoiceModel?.departmentId"
                                (valueChanged)="updateAccountLedgerDropdownSource($event)" [id]="'departmentDropdown'"
                                [name]="'departmentDropdown'" [isDisabled]="false">
                            </app-select>
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel.showFromBranchDropdown" class="col-3 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="category"
                                class="f-14 font-semibold text-gray-color text-nowrap mb-0">From Branch</label>
                        </div>
                        <div class="w-100">
                            <app-select [options]="getAllDropdownModel?.branchDropdown"
                                [selectedValue]="formModel?.invoiceModel?.fromBranchId"
                                [id]="'departmentDropdown'"
                                [name]="'departmentDropdown'" [isDisabled]="false">
                            </app-select>
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel?.showToBranchDropdown" class="col-3 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="category"
                                class="f-14 font-semibold text-gray-color text-nowrap mb-0">To Branch</label>
                        </div>
                        <div class="w-100">
                            <app-select [options]="getAllDropdownModel?.branchDropdown"
                                [selectedValue]="formModel?.invoiceModel?.toBranchId"
                                [id]="'departmentDropdown'"
                                [name]="'departmentDropdown'" [isDisabled]="false">
                            </app-select>
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel?.showAccountLedgerDropdown"
                        class="col-md-7 col-xl-6 p-0 d-flex align-items-center gap-1">
                        <div class="">
                            <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0">
                                Name 
                              <span *ngIf="commonVoucherModel?.isAccountLedgerValidRequird" class="text-color-danger">*</span>
                            </label>
                        </div>
                        <div class="col w-inherit">
                            <app-custom-select2   
                            [customId]="'name'" [dropdownMandatory]="true" [formModel]="formModel" (valueChanged)="assignAccountLedgerId($event)"
                                (keyEnter)="checkPresentInLedgerList($event)">
                            </app-custom-select2>                        
                        </div>
                        <div class="d-flex">
                            <app-svg-icon 
                            name="info" 
                            (click)="(formModel?.invoiceModel?.accountLedgerId && commonVoucherModel?.accountLedgerPopUp) ? openCustomerDetailsSlider('Edit') : null"
                            [ngbTooltip]="sendDataService?.noPermissionTooltip"
                            [disableTooltip]="commonVoucherModel?.accountLedgerPopUp"
                            [ngClass]="{
                            'opacity-50': !commonVoucherModel?.accountLedgerPopUp || !formModel?.invoiceModel?.accountLedgerId,
                            'cursorPointer': commonVoucherModel?.accountLedgerPopUp && formModel?.invoiceModel?.accountLedgerId
                            }">
                        </app-svg-icon>                          
                        </div>
                        <div class="">
                            <app-svg-icon name="plus_circle" 
                                (click)="(commonVoucherModel?.accountLedgerPopUp) ? openCustomerDetailsSlider('Add' , customSelect2Component?.select2Ref?.innerSearchText) : null"
                                [ngbTooltip]="sendDataService?.noPermissionTooltip"
                                [disableTooltip]="commonVoucherModel?.accountLedgerPopUp"
                                [ngClass]="{'opacity-50':!commonVoucherModel?.accountLedgerPopUp ,'cursorPointer': commonVoucherModel?.accountLedgerPopUp}"
                                >
                            </app-svg-icon>
                        </div>
                        <div class="">
                            <app-svg-icon name="scan" class="cursorPointer"
                            (click)="openWithReaderDetailsPopup('Add' , customSelect2Component?.select2Ref?.innerSearchText)">
                            </app-svg-icon>
                        </div>
                        <div class="w-162 d-flex align-items-center px-0 gap-2" *ngIf="commonVoucherModel?.isShowReferenceNo">
                            <div class="">
                                <label class="f-14 font-semibold text-gray-color text-nowrap mb-0"> Ref No.
                                </label>
                            </div>
                            <div class="w-100">
                                <app-input
                                [inputName]="'referenceNo'"
                                [inputType]="'text'" [inputId]="'referenceNo'"
                                [inputValue]="formModel.invoiceModel?.referenceNo"
                                (inputValueEmit)="formModel.invoiceModel.referenceNo = $event"
                                (keydown.enter)="onKeydown($event, 'salesPersonDropdown')">
                                </app-input>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="commonVoucherModel.showVoucherTypeDropdown"
                        class="col-3 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Voucher
                                Type</label>
                        </div>
                        <div class="w-100">
                            <app-custom-select2 
                                #voucherTypeDropdown  
                                [customId]="'voucherTypeDropdown'"
                                [whichDropdown]="storage.VOUCHER_TYPE_DROPDOWN" 
                                [formModel]="formModel" 
                                (valueChanged)="formModel.invoiceModel.againstVoucherTypeId=$event;getAgainstData()">
                            </app-custom-select2>
                            <!-- <app-select 
                                [optionDisable]="false"
                                [options]="getAllDropdownModel.voucherTypeDropdown"
                                [selectedValue]="formModel.invoiceModel.againstVoucherTypeId"
                                (valueChanged)="formModel.invoiceModel.againstVoucherTypeId=$event;getAgainstData()"
                                [id]="'againstVoucherTypeId'" [name]="'againstVoucherTypeId'" [isRequired]="false"
                                [isDisabled]="false">
                            </app-select> -->
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel?.showAgainstInvoiceDropdown"
                        class="col-2 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="againstVoucherNo"
                                class="f-14 font-semibold text-gray-color text-nowrap mb-0">Against</label>
                        </div>
                        <div class="w-100">
                        <app-custom-select2 
                            #againstInvoiceDropdown  
                            [customId]="'branchDropdown'"
                            [whichDropdown]="storage.AGAINST_DROPDOWN" 
                            [formModel]="formModel" 
                            (valueChanged)="formModel.invoiceModel.againstVoucherNo=$event;assignAgainstInvoiceNo($event)">
                        </app-custom-select2>
                            <!-- <app-select [options]="copiedAgainstDropdown"
                                [selectedValue]="formModel.invoiceModel.againstInvoiceNo"
                                (valueChanged)="formModel.invoiceModel.againstVoucherNo=$event;assignAgainstInvoiceNo($event)"
                                [id]="'againstVoucherNo'" [name]="'againstVoucherNo'" [isDisabled]="false" [isRequired]="false">
                            </app-select> -->
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel?.isShowSalesperson"
                        class="col-md-3 col-xl-4 p-0 d-flex align-items-center gap-2">
                        <div class="">
                            <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Sales
                                Person</label><span *ngIf="formModel?.invoiceModel?.salesPersonMandatory" class="text-color-danger">*</span>
                        </div>
                        <div class="col w-inherit">
                            <app-select 
                                [optionDisable]="formModel?.invoiceModel?.salesPersonMandatory? null : ''"
                                [options]="getAllDropdownModel?.salePersonDropdown"
                                [selectedValue]="formModel?.invoiceModel?.salePersonId"
                                (valueChanged)="formModel.invoiceModel.salePersonId = $event ? $event :'0'"
                                [id]="'salesPersonDropdown'" [name]="'salesPersonDropdown'" [isDisabled]="layoutDetails?.roleName === 'Sales Person'"
                                [isRequired]="formModel?.invoiceModel?.salesPersonMandatory"
                                (keydown.enter)="onKeydown($event, 'againstofDropdown')">
                            </app-select>
                        </div>
                        <!-- <div class="" (click)="openAddEditUserPopUp()" >
                        <img class="px-0 cursorPointer " src="./assets/svg/plus_circle.svg" alt="circle_plus">
                    </div> -->
                    </div>
                    <div *ngIf="commonVoucherModel?.isShowAgainstOf"
                        class="col-xl-2 col-md-3 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Against
                                Of</label>
                        </div>
                        <div class="w-100">
                            <app-select [options]="getAllDropdownModel?.againstofDropdown"
                                [selectedValue]="formModel?.invoiceModel?.againstOfId"
                                (valueChanged)="formModel.invoiceModel.againstOfId=$event;onAgainstOfChange($event)"
                                [id]="'againstofDropdown'" [name]="'againstofDropdown'" [isDisabled]="false"
                                [isEstimate]="true" [optionDisables]="customSelect2Component?.id ? [] : ['1','2','3','4','5','6','7','8'] "
                                [isRequired]="false" (keydown.enter)="onKeydown($event, 'currencyExchange')">
                            </app-select>
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel?.isShowCurrency"
                        class="col-2 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Currency</label>
                        </div>
                        <div class="d-flex justify-content-between select_input_combine_container">
                            <div class="border-gray1-right col-7">
                                <app-select [options]="getAllDropdownModel?.currencyExchangeDropdown"
                                [selectedValue]="formModel?.invoiceModel?.exchangeRateId"
                                (valueChanged)="onExchangeRateChange($event)" 
                                [id]="'currencyExchange'" [name]="'currencyExchange'" [isDisabled]="false"
                                [isRequired]="false" (keydown.enter)="onKeydown($event, 'currencyExchangeRateId')"
                                >
                                </app-select>
                            </div>
                            <div>
                                <app-input 
                                [inputName]="'currencyExchangeRate'" 
                                [inputType]="'text'" 
                                [inputId]="'currencyExchangeRateId'" 
                                [isRequired]="false"
                                [inputValue]="formModel?.invoiceModel?.currencyExchangeRate"
                                (inputValueEmit)="formModel.invoiceModel.currencyExchangeRate = $event"
                                (keydown.enter)="onKeydown($event, 'invoiceDate')"
                                [decimalRestrictedDigit]="2"
                                [isBlureApplicable]="true"
                                [applyDecimalOrPercent]="true"
                                >
                                </app-input>
                        </div>
                        </div>
                        <div class="">
                            <app-svg-icon name="plus_circle" [ngClass]="formModel?.invoiceModel?.exchangeRateId ? 'cursorPointer' : 'pointer_none'"
                                (click)="AddUpdateExchangeRate()">
                            </app-svg-icon>
                        </div>
                    </div> 
                    <div class="w-140 p-0 d-flex align-items-center" *ngIf="commonVoucherModel.showgozUsdRate">
                        <div class="">
                        <label class="f-14 font-semibold text-gray-color text-nowrap mb-0 pe-2"> Goz
                        </label>
                        </div>
                        <div class="w-100">
                        <app-input
                            [isBlureApplicable]="false"
                            [applyDecimalOrPercent]="true"
                            [decimalRestrictedDigit]="4"
                            [inputName]="'ounceRate'"
                            [inputType]="'text'"
                            [inputId]="'ounceRate'"
                            [inputValue]="formModel?.invoiceModel?.ounceRate || '0'"
                            (inputValueEmit)="formModel.invoiceModel.ounceRate = $event ? $event :'0';">
                        </app-input>
                        </div>
                    </div>
                    <div class="w-140 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="date"
                                class="f-14 font-semibold text-gray-color text-nowrap mb-0">Date</label>
                        </div>
                        <div class="w-100">
                            <!-- <app-range-datepicker
                            [displayMonths]="1" 
                            [formatMMddyyyy]="true"
                            [fromEdit]="true"
                            (dateInStringFormat)="selectedRangeDates($event)"
                            [datepickername]="'customDatePicker'"
                            [inputDate]=""
                            ></app-range-datepicker> -->
                            <app-input-datepicker-renderer [isDatepickerChangeByType]="true" #invoiceDateComp [inputDate]="invoiceDate" [id]="'invoiceDate'" [inputDatepickerName]="'invoiceDate'"
                                (dateChanged)="selectedRangeDates($event)"
                                (keydown)="onKeydown($event,'dueDate')"></app-input-datepicker-renderer>
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel?.isShowDueDate" class="w-162 p-0 d-flex gap-2 align-items-center me-1">
                        <div class="">
                            <label for="dueDate" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Due
                                Date</label>
                        </div>
                        <div class="w-100">
                            <app-input-datepicker-renderer #dueDateComp [inputDate]="dueDate"  [id]="'dueDate'" [inputDatepickerName]="'dueDate'"
                                (dateChanged)="selectedDueDateRangeDates($event)"
                                (keydown)="onKeydown($event,'barcode')"></app-input-datepicker-renderer>
                        </div>
                    </div>
                    <div *ngIf="commonVoucherModel?.isshowLayawaysDropdown"
                        class="col-xl-3 col-md-5 d-flex align-items-center gap-1 px-0">
                        <div class="">
                            <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0 me-1">Layaways</label>
                        </div>
                        <div class="col">
                            <app-custom-select2   
                            [customId]="'layawaysDropdown'" #layawaysDropdown [formModel]="formModel" (valueChanged)="assignLayawaysId($event)"
                            [whichDropdown]="storage.SCHEME_NAME_DROPDOWN"></app-custom-select2>
                        </div>
                        <div class="d-flex">
                            <app-svg-icon 
                            name="info" 
                            (click)="(formModel?.invoiceModel?.schemeId && commonVoucherModel?.layawaysPopUp) ? OpenCreateUpdateSchemeSlider('Update') : null"
                            [ngbTooltip]="sendDataService?.noPermissionTooltip"
                            [disableTooltip]="commonVoucherModel?.layawaysPopUp"
                            [ngClass]="{
                            'opacity-50': !commonVoucherModel?.layawaysPopUp || !formModel?.invoiceModel?.schemeId,
                            'cursorPointer': commonVoucherModel?.layawaysPopUp && formModel?.invoiceModel?.schemeId 
                            }">
                            </app-svg-icon>                        
                        </div>
                        <div class="">
                            <app-svg-icon name="plus_circle" 
                                (click)="(commonVoucherModel?.layawaysPopUp) ? OpenCreateUpdateSchemeSlider('Create' , layawaysDropdown?.select2Ref?.innerSearchText) : null"
                                [ngbTooltip]="sendDataService?.noPermissionTooltip"
                                [disableTooltip]="commonVoucherModel?.layawaysPopUp"
                                [ngClass]="{'opacity-50':!commonVoucherModel?.layawaysPopUp ,'cursorPointer': commonVoucherModel?.layawaysPopUp}"
                                >
                            </app-svg-icon>
                        </div>  
                    </div>
                    <div *ngIf="commonVoucherModel?.isShowFixingType" class="col-xl-2 col-md-4 p-0 d-flex gap-2 align-items-center">
                        <div class="">
                            <label for="fixingType"
                                class="f-14 font-semibold text-gray-color text-nowrap mb-0">Fixing Type</label>
                        </div>
                        <div class="w-100">
                            <app-select [options]="getAllDropdownModel?.fixingTypeDropdown"
                                [selectedValue]="formModel?.invoiceModel?.fixingTypeId"
                                (valueChanged)="selectHedging($event)" [id]="'fixingTypeId'"
                                [name]="'fixingTypeName'" [isDisabled]="false">
                            </app-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2 px-0">
                <div class="row py-1 mx-0">
                    <div class="d-flex align-items-center justify-content-end px-0">
                    <div class="d-flex align-items-center">
                        <div class="mt-1 pe-1" *ngIf="formModel?.invoiceModel?.id && commonVoucherModel?.showJournalVouchersPopupIcon">
                            <app-svg-icon [ngbTooltip]="'View Journal Vouchers'" [container]="'body'" name="weight" class="cursorPointer" (click)="openJournalVouchersPopup()"></app-svg-icon>
                        </div>
                        <div>
                            <app-upload-documents *ngIf="commonVoucherModel?.showUploadDocumentButton"
                               [ngbTooltip]="'Upload Document'" [container]="'body'" [requestModel]="formModel"></app-upload-documents>
                        </div>
                    </div>
                        <div class="d-flex align-items-center gap-1">
                            <app-button *ngIf="commonVoucherModel.showNewInvoiceButton" class="" [buttonId]="'newInvoice'" [buttonLabel]="'New +'"
                                [buttonClass]="'pink_button text-nowrap'" [buttonType]="'button'"
                                (buttonOutputEvent)="newInvoice()">
                            </app-button>
                            <app-button *ngIf="commonVoucherModel?.showSaveInvoiceButton" [ngbTooltip]="formModel?.isInReference ? (sendDataService?.noPermissionTooltip) : ('You cannot update this ' + voucherTypeName + ', it is already in use.')"
                                [disableTooltip]="(this.formModel?.invoiceModel?.id ? (commonVoucherModel?.invoiceCanUpdate && formModel?.isInReference) : commonVoucherModel?.invoiceCanAdd)"
                                [disabled]="!(this.formModel?.invoiceModel?.id ? (commonVoucherModel?.invoiceCanUpdate && formModel?.isInReference) : commonVoucherModel?.invoiceCanAdd)"
                                class="" [buttonLabel]="'Save'" [buttonClass]="'blue_button'" [buttonId]="'save_invoice'"
                                [buttonType]="'submit'" (buttonOutputEvent)="onSave()">
                            </app-button>
                            <div *ngIf="commonVoucherModel?.printBarcodeButton" class="d-flex align-items-center justify-content-end">
                                <app-button class="" [buttonLabel]="'Print Barcode'" [disabled]="barcodeDisabled()"
                                    (buttonOutputEvent)="onPrintBarcodeClick()" [buttonClass]="'blue_button'" [buttonType]="'button'">
                                </app-button>
                            </div>
                            <div *ngIf="commonVoucherModel?.isRecievedButton">
                                <app-button [disabled]="!checkIfRowSelected()" [ngClass]="{'d-none':hideRecieveButton}" [buttonLabel]="'Recieved'" [buttonClass]="'pink_button'" (buttonOutputEvent)="updateStockTransferReceivedStatus()"  [buttonType]="'button'"></app-button>
                            </div>
                            <div class="d-flex align-items-center justify-content-end f-13" *ngIf="commonVoucherModel?.showExpensesWithTaxSwitch">
                                <!-- <div class="d-flex align-items-center text-primary font-regular">{{fileName}}</div> -->
                                <div *ngIf="fileName" [ngbTooltip]="fileName"  placement="left" tooltipClass="tooltip-custom" class="me-2">
                                 <app-svg-icon name="importFile" class="cursorPointer" (click)="uploadFile()"></app-svg-icon>
                                </div>
                                <div class="col add_Import_dropdown position-relative"> 
                                    <div ngbDropdown class="d-inline-block w_90">
                                        <button type="button" class="btn w-100" id="dropdownBasic1" ngbDropdownToggle>
                                            &nbsp;
                                            &nbsp;
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                            <div class="form-check d-flex" ngbDropdownItem>
                                                <div class="d-flex align-items-center"><app-svg-icon name="import" class="cursorPointer" ></app-svg-icon></div>
                                                <input #importFile type="file" id="import" name="import" (change)="onFileSelected($event)" class="d-none" accept=".xls,.xlsx">
                                                <label for="import" class="d-flex align-items-center mb-0 f-12 ps-1 font-regular cursorPointer color-dark-gray mb-0">
                                                    Import
                                                </label>
                                            </div>
                                            <div class="form-check d-flex" ngbDropdownItem (click)="downloadSampleFile()">
                                                <div class="d-flex align-items-center"><app-svg-icon name="importsample" class="cursorPointer" ></app-svg-icon></div>
                                                <label for="sample" class="d-flex align-items-center mb-0 f-12 ps-1 cursorPointer font-regular color-dark-gray mb-0 f-12">
                                                    Sample
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add_ExportImport_button" (click)="dropdown?.toggle()">
                                        <button type="button" class="btn  p-0" id="addImport">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 16.875 16.875">
                                                <path id="Union_4" data-name="Union 4" d="M7.438-1a.938.938,0,0,1,.937.938V6.5h6.563a.937.937,0,1,1,0,1.875H8.375v6.563a.937.937,0,1,1-1.875,0V8.375H-.062A.938.938,0,0,1-1,7.438.938.938,0,0,1-.062,6.5H6.5V-.062A.938.938,0,0,1,7.438-1Z" transform="translate(1 1)" fill="#fff"/>
                                                </svg>  
                                            </span>
                                            <span>
                                                Import
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                <!-- <div class="row py-1 mx-0">
                    {{formModel.balanceResult}}
                </div> -->
            </div>
        </div>
        <div *ngIf="commonVoucherModel?.isJobworkOrder" class="row py-1 gap-2 mx-0">
            <div class="col-2 d-flex align-items-center gap-2 p-0">
                <div class="">
                    <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Customer</label>
                </div>
                <div class="w-100">
                    <app-input [readOnly]="true" [inputName]="'customerName'" [inputType]="'text'"
                        [inputId]="'customerNameId'" [inputValue]="formModel?.invoiceModel?.customerName"
                        (inputValueEmit)="formModel.invoiceModel.customerName = $event" [isRequired]="false"
                        (keydown.enter)="onKeydown($event, '')">
                    </app-input>
                </div>
            </div>
            <div class="col-2 d-flex align-items-center gap-2 p-0">
                <div class="">
                    <label for="againstRefNo" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Against Ref No</label>
                </div>
                <div class="w-100">
                    <app-input [inputName]="'againstRefNo'" [inputType]="'text'" [inputId]="'againstRefNo'"
                        [inputValue]="formModel?.invoiceModel?.againstRefNo"
                        (inputValueEmit)="formModel.invoiceModel.againstRefNo = $event" [isRequired]="false"
                        (keydown.enter)="onKeydown($event, '')">
                    </app-input>
                </div>
            </div>
            <div class="col-2 p-0 d-flex gap-2 align-items-center">
                <div class="">
                    <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Status<span
                            class="text-color-danger">*</span></label>
                </div>
                <div class="w-100">
                    <app-select [options]="getAllDropdownModel?.jobWorkStatusDropdown"
                        [selectedValue]="formModel?.invoiceModel?.statusId"
                        (valueChanged)="formModel.invoiceModel.statusId = $event;updateJobworkOrderStatus($event);"
                        [id]="'statusDropdown'" [name]="'statusDropdown'" [isDisabled]="false">
                    </app-select>
                </div>
            </div>
            <div class="col-2 p-0 d-flex gap-2 align-items-center">
                <div class="">
                    <label for="category" class="f-14 font-semibold text-gray-color text-nowrap mb-0">Priority<span
                            class="text-color-danger">*</span></label>
                </div>
                <div class="w-100">
                    <app-select [options]="getAllDropdownModel?.jobWorkPriorityDropdown"
                        [selectedValue]="formModel?.invoiceModel?.priorityId"
                        (valueChanged)="formModel.invoiceModel.priorityId  = $event;updateJobworkOrderPriority($event);"
                        [id]="'priorityDropdown'" [name]="'priorityDropdown'" [isDisabled]="false">
                    </app-select>
                </div>
            </div>
            <div class="due_date p-0 d-flex gap-2 align-items-center">
                <div class="">
                    <label for="dueDate" class="f-14 font-semibold text-gray-color text-nowrap mb-0 "> {{ commonVoucherModel?.isDurationDate ? 'Duration Date' : 'Due Date' }}</label>
                </div>
                <div class="w-100">
                    <app-input-datepicker-renderer #dueDateComp [inputDate]="dueDate" (dateChanged)="dueDate = $event"
                        (keydown)="keyDown($event,'barcode')"></app-input-datepicker-renderer>
                </div>
            </div>
        </div>
        <hr class="my-0 border-gray-color">
    </form>
 <!-- Common Metal Group -->
<!-- <div *ngIf="commonVoucherModel.showMetalSection">
    <app-metal-section 
    [formName]="commonVoucherModel.formName" 
    [formModel]="formModel"
    [metalSectionModel]="metalSectionModel"
    >
</app-metal-section>
</div> -->

<div class="mb-0" *ngIf="commonVoucherModel?.showMetalSectionSimple">
    <app-metal-section-child (onGridReadyCompleted)="gridReadyCompleted($event)"
        [data]="{ formModel: formModel, formName: commonVoucherModel?.formName, metalSectionModel:metalSectionModel }"
        [isPopup]="false">
    </app-metal-section-child>
</div>
<div class="mt-2 position-relative"  *ngIf="commonVoucherModel?.showExpensesWithTaxSwitch">
    <app-ag-grid 
    id="ExpensesGrid" 
    [gridOptions]="gridOptions"
    [dataModel]="agGridDataModelExpensesGrid"
    (gridReady)="onGridReady($event ,1)" 
    (onDeleteIconClick)="onDeleteExpense()"
    [columnSettings]="true"
    (cellValueChanged)="onCellValueChangedDetect($event)"
    >
</app-ag-grid>
</div>


    <!-- Common Metal Group -->
    <div class="flex-fill">
        <div class="d-flex flex-column h-100" container="body">
            <div [ngClass]="{'flex-fill' : !(commonVoucherModel?.showPaymentAndReciptVoucherNewDesign)}" class="row mx-0 mt-0 gap-2 mb-2">
                
                <div class="col h-100 px-0">
                    <div *ngIf="commonVoucherModel?.showMetalSection">
                        <app-metal-section 
                        (onGridReadyCompleted) = "gridReadyCompleted($event)"
                        [formName]="commonVoucherModel?.formName" 
                        [formModel]="formModel"
                        [metalSectionModel]="metalSectionModel"
                        [getAllDropdownModel]="getAllDropdownModel"
                        >
                    </app-metal-section>
                    </div>
                    <div class="row mx-0 gap-2">
                        <div *ngIf="commonVoucherModel?.showItemListection"  class="col p-0">
                            <app-item-list-section 
                            [formName]="commonVoucherModel?.formName" 
                            [formModel] = "formModel"
                            [SampleFileData] = "sampleFileData"
                            (onItemListChange) = "onItemListChange($event)" 
                            (onItemListRowClick) = "onItemListRowClick($event)"
                            (onDeleteItemClick) = "onDeleteItemClick($event)"
                            [itemSectionModel]="itemSectionModel"
                            ></app-item-list-section>
                           <!-- item list -->
                        </div>
                        <div *ngIf="commonVoucherModel?.showTaxSection" class="tax_details p-0">
                            <app-tax-section [formModel]="formModel"
                            (onItemListChange) = "onItemListChange($event)" 
                                [taxSectionModel]="taxSectionModel"></app-tax-section>

                        </div>
                    </div>
                    <div class="col d-flex flex-column h-100 p-0"  *ngIf="commonVoucherModel?.showfixingDirectGridSection">
                        <div class="h-0 flex-fill">
                        <app-ag-grid                         
                        [dataModel]="agGridDataModelSalePurchaseFixingDirectGrid"
                        [columnSettings]="true"
                        (gridReady)="onGridReady($event,2)"
                        (onDeleteIconClick)="onDeleteFixingDirect($event)"
                        (cellValueChanged)="onCellValueFixingDirectChangedDetect($event)"
                      >
                        </app-ag-grid>
                        </div>
                        <form >
                        <div class="row flex">
                            <div class="PurchaseFixingtable">
                                <table class="table border">
                                    <thead> 
                                    </thead>
                                    <tbody>
                                        <tr class="border font-semibold">
                                            <td class="border-right pt-2 align-middle" width="5%">Comment</td>                            
                                            <td class="border-right p-0 px-1 align-middle py-1" width="22%">
                                                <app-input 
                                                [inputName]="'comment'" 
                                                [inputType]="'text'"
                                                [inputId]="'comment'" 
                                                [inputValue]="formModel?.invoiceModel?.comment"
                                                (inputValueEmit)="formModel.invoiceModel.comment = $event" 
                                                [isRequired]="false"
                                                >
                                            </app-input>
                                            </td>
                                            <td class="text-center pt-2 border-right align-middle" width="8%">Total Gross Wt.</td>
                                            <td class="text-center f-14 font-semibold text-gray-color bg-gray pt-2 align-middle" width="10%">{{formModel?.invoiceModel?.totalGrossWt?.toFixed(3)}}</td>
                                            <td class="text-center pt-2 border-right align-middle" width="8%">Total Purity Wt.</td>
                                            <td class="text-center f-14 font-semibold text-gray-color bg-gray pt-2 align-middle" width="10%">{{formModel?.invoiceModel?.totalPurityWt?.toFixed(3)}}</td>
                                            <td class="text-center border-right pt-2 align-middle" width="8%">Total Amount</td>
                                            <td class="text-center f-14 font-semibold text-gray-color bg-gray pt-2 align-middle" width="10%">{{formModel?.invoiceModel?.totalamount?.toFixed(2)}}</td>
                                        </tr>
                                    </tbody> 
                                </table> 
                            </div>
                        </div>
                    </form>
                    </div>

                    <div *ngIf="commonVoucherModel?.showPaymentSection" [ngClass]="{'disabled-div': isHidePaymentSection === true}">
                    <app-payment-section 
                    [formModel]="formModel" 
                    (onFundTransfer) = "onFundTransfer($event)" 
                    [paymentSectionModel]="paymentSectionModel"
                    [isbackedDataModelPopup]= "isbackedDataModelPopup"
                    (onPaymentListChanged)="onPaymentListChanged($event)"
                     ></app-payment-section>

                    </div>
                    <app-common-comment *ngIf="commonVoucherModel?.showCommentSection" [inputName]="'commonVoucherComment'" [inputId]="'commonVoucherComment'" [formModel]="formModel"></app-common-comment>
                    <div *ngIf="commonVoucherModel?.showPaymentListSection && !(commonVoucherModel.showPaymentAndReciptVoucherNewDesign)" class="col-12 px-0">
                        <ng-container *ngTemplateOutlet="paymentList"></ng-container>
                    </div>
                </div>
                <div *ngIf="commonVoucherModel?.showTotalSection" class="invoice_total h-100 d-flex flex-column px-0">
                    <app-total-section [formModel]="formModel"
                        [totalSectionModel]="totalSectionModel" 
                        [selectedCurrencyName]="selectedCurrencyName" [selectedBaseCurrencyName]="selectedBaseCurrencyName"></app-total-section>
                </div>

            </div>
            <div *ngIf="commonVoucherModel?.showPaymentListSection && commonVoucherModel?.showPaymentAndReciptVoucherNewDesign" class="col-12 px-0">
                <ng-container *ngTemplateOutlet="paymentList"></ng-container>
            </div> 
        </div>
    </div>
</div>

<ng-template #paymentList>
    <app-payment-list (onEditIconClicked)="onEditPaymentClicked($event)" [paymentListSectionModel]="paymentListSectionModel"
    [voucherType]="commonVoucherModel?.controllerName" [getAllDropdownModel]="getAllDropdownModel"></app-payment-list>
</ng-template>